/*
 * Vairok · menú (04/10/2026)
 * 1. Megamenú de escritorio: se abre al pasar el ratón (con una pequeña espera para no abrirse al cruzar),
 *    con el teclado (Tab/Enter, flecha abajo) y se cierra con Esc o al salir. Mantiene aria-expanded.
 *    Sin JS sigue funcionando el :hover/:focus-within del tema (la clase vk-js solo existe con JS).
 * 2. Contador del carrito: se oculta cuando es 0 (el tema solo cambia el número).
 * 3. Botón del menú móvil: aria-expanded según el cajón abierto o cerrado.
 */
(function () {
  'use strict';

  /* 1. Megamenú */
  var menu = document.querySelector('.header .thb-full-menu');
  if (menu) {
    var full = menu.closest('full-menu');
    if (full) full.classList.add('vk-js');
    var items = Array.prototype.slice.call(menu.querySelectorAll(':scope > li.menu-item-has-children'));
    var openTimer = null;
    var closeTimer = null;

    var setOpen = function (li, open) {
      var a = li.querySelector(':scope > a');
      li.classList.toggle('vk-open', open);
      if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var closeAll = function (except) {
      items.forEach(function (li) { if (li !== except) setOpen(li, false); });
    };
    var anyOpen = function () {
      return items.some(function (li) { return li.classList.contains('vk-open'); });
    };

    items.forEach(function (li) {
      var a = li.querySelector(':scope > a');
      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        // Si ya hay uno abierto, cambiar sin espera; si no, una espera corta para no abrir al cruzar
        openTimer = setTimeout(function () { closeAll(li); setOpen(li, true); }, anyOpen() ? 0 : 120);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { setOpen(li, false); }, 180);
      });
      li.addEventListener('focusin', function () { closeAll(li); setOpen(li, true); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) setOpen(li, false);
      });
      if (a) {
        a.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            var first = li.querySelector('.sub-menu a');
            if (first) { e.preventDefault(); setOpen(li, true); first.focus(); }
          }
        });
      }
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && li.classList.contains('vk-open')) {
          setOpen(li, false);
          if (a) a.focus();
          // Mantener cerrado aunque el foco siga dentro hasta el siguiente movimiento
          li.classList.add('vk-esc');
          setTimeout(function () { li.classList.remove('vk-esc'); }, 0);
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && anyOpen()) closeAll();
    });
    window.addEventListener('scroll', function () { if (anyOpen() && !menu.matches(':hover')) closeAll(); }, { passive: true });
  }

  /* 2. Contador del carrito: oculto cuando es 0 */
  var syncCount = function (el) {
    var n = (el.textContent || '').trim();
    el.classList.toggle('vk-count--empty', n === '0' || n === '');
  };
  document.querySelectorAll('.thb-secondary-cart .thb-item-count').forEach(function (el) {
    syncCount(el);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { syncCount(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    }
  });

  /* 3. Botón del menú móvil */
  var toggle = document.querySelector('.mobile-toggle');
  var drawer = document.getElementById('mobile-menu');
  if (toggle && drawer) {
    toggle.setAttribute('aria-controls', 'mobile-menu');
    toggle.setAttribute('aria-expanded', 'false');
    document.addEventListener('panel:open', function (e) { if (e.detail && e.detail.panel === drawer) toggle.setAttribute('aria-expanded', 'true'); });
    document.addEventListener('panel:closed', function (e) { if (e.detail && e.detail.panel === drawer) toggle.setAttribute('aria-expanded', 'false'); });
  }
})();
